import { useMemo } from "react";
import { useDLMApplicationView } from "../../context/DLMApplicationViewProvider";
import { 
  DetailCard,
  DetailFileDownload,
  DetailLabelKeysToFiles
} from "../../../../../components/layout"

const DLM_SUPPORTDOC_FIELDS = {
  podo: 'Company PO',
  approvalAttachment: 'SCDF Notice Of Approval',
  doHolder: 'Delivery Order from COC Holder to Purchaser',
  poHolder: 'Purchase Order From Purchaser to COC Holder',
  caHolder: 'Contract Agreement Between COC Holder and Purchaser',
  labelRecord: 'Previous Label Distribution Record',
};

const SupportingDocuments = () => {

  const { dlmAppData: dat } = useDLMApplicationView();

  const { hasDocuments } = useMemo(() => {
      if (dat === undefined) return { hasDocuments : false};

      const hasDocuments = (
        dat?.approvalAttachment ||
        dat?.doHolder ||
        dat?.poHolder ||
        dat?.caHolder ||
        dat?.labelRecord ||
        (dat?.otherAttachments && dat.otherAttachments.length > 0)
    )

    return { hasDocuments };

  }, [dat])

  if (! (dat !== undefined && hasDocuments)) {
      return null;
  }

  return(
  <DetailCard cardTitle="Supporting Documents">
    {DetailLabelKeysToFiles(DLM_SUPPORTDOC_FIELDS, dat, true)}
    { (dat?.otherAttachments && dat.otherAttachments.length > 0) &&
    <>
    <label className="mt-4 fw-bold fs-5">Other Attachments</label>
    <div className="mh-150px overflow-auto pe-6 me-n4">
    { dat.otherAttachments.map((file: any, idx: number) => (
        <DetailFileDownload key={`otherFile${idx}`} labelText={`File ${idx + 1}`} file={file} wideLabel={true} />
    ))}
    </div>
    </>
    }
  </DetailCard>
  )
}

export { SupportingDocuments } 